import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../../components/auth/auth.selector";
import HelmetWrapper from "../../../HelmetWrapper";
import CommonStructured from "../../../components/common-components/CommonStructured";
import CmnFilters from "../../../components/lead-management/common/CmnFilters";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import SendyListListings from "../../../components/broadcast-system/sendy/SendyListListings";
import SendyListForm from "../../../components/broadcast-system/sendy/SendyListForm";
import SubscriberForm from "../../../components/broadcast-system/sendy/SubscriberForm";
import { fetchSendyListsData } from "../../../redux/ad-blog-reducers/blogSlice";

const SendyLists = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { sendyListsLoading } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [refreshCounter, setRefreshCounter] = useState(0);

  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getSendyListsData = (filters) => {
    dispatch(
      fetchSendyListsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const triggerRefresh = () => {
    getSendyListsData(filters);
    setRefreshCounter((prev) => prev + 1);
  };

  useEffect(() => {
    getSendyListsData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Campaign Lists">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-50p">
            <ModalHeadAndClose
              title={
                modValues.modName === "description"
                  ? modValues.rowData?.template_name
                  : modValues.modName === "add" || modValues.modName === "edit"
                  ? `${modValues.modName} List`
                  : modValues.modName === "addSubscriber"
                  ? "Add New Subscriber"
                  : modValues.modName === "editSubscriber"
                  ? "Edit Subscriber"
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description || "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <SendyListForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={triggerRefresh}
              />
            ) : modValues.modName === "addSubscriber" ||
              modValues.modName === "editSubscriber" ? (
              <SubscriberForm
                isEdit={modValues.modName === "editSubscriber"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={triggerRefresh}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"List Monk"}
              isReload={() => getSendyListsData(filters)}
              createBtnTxt={"+ Add New List"}
              createBtnTxt1={"Add New Subscriber"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              onClickCreateBtn1={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "addSubscriber",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="plans-categories"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={sendyListsLoading}
              searchPlaceHolder="Search by list name..."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SendyListListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={triggerRefresh}
              refreshCounter={refreshCounter}
              filters={allFilters}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default SendyLists;
